import { ref } from 'vue';

const toasts = ref<Array<{ id: number; message: string; type: 'success' | 'error' | 'warning' | 'info'; visible: boolean }>>([]);
let nextId = 0;

export function useToast() {
  function show(message: string, type: 'success' | 'error' | 'warning' | 'info' = 'info', duration = 4000) {
    const id = nextId++;
    toasts.value.push({ id, message, type, visible: true });
    setTimeout(() => {
      const idx = toasts.value.findIndex(t => t.id === id);
      if (idx !== -1) toasts.value.splice(idx, 1);
    }, duration);
  }

  return {
    toasts,
    success: (msg: string) => show(msg, 'success'),
    error: (msg: string) => show(msg, 'error'),
    warning: (msg: string) => show(msg, 'warning'),
    info: (msg: string) => show(msg, 'info'),
    dismiss: (id: number) => {
      const idx = toasts.value.findIndex(t => t.id === id);
      if (idx !== -1) toasts.value.splice(idx, 1);
    },
  };
}
